export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    align: 'center',
    fixed: 'right',
    width: 90,
    showHeaderOverflow: true,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_custNo') || '客户编号',
    field: 'custNo',
    width: 125,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custNoame') || '客户名称',
    field: 'displayName',
    minWidth: 250,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_custApprovalNode') || '审批节点',
    field: 'custApprovalNode',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'custApprovalNode' },
  },
  {
    title: that.$l('table_label_approvalStatus') || '节点状态',
    field: 'approvalStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'approvalStatus' },
  },
  {
    title: that.$l('table_label_custApprovalRequestType') || '业务类型',
    field: 'custApprovalRequestTypeName',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displaySalesDep') || '所属部门',
    field: 'depName',
    minWidth: 160,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_orgName') || '所属公司',
    field: 'orgName',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
  },

  {
    title: that.$l('table_title_createByName') || '创建人',
    field: 'displayCreate',
    width: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
]
